export const YOUTUBE_ID_REGEX = /^[a-zA-Z0-9_-]{11}$/;
export const DEFAULT_VIDEO_ID = "KtVUwQEhBMA";

export const VIDEO_IDS = new Map([
  ["en", "KtVUwQEhBMA"],
  ["es", "rjutt3aeDLE"],
  ["pt-BR", "62qMH_XLTfI"],
]);

export function getVideoId(language) {
  const videoId = VIDEO_IDS.get(language) || VIDEO_IDS.get("en");
  const id = YOUTUBE_ID_REGEX.test(videoId) ? videoId : VIDEO_IDS.get("en");
  return id;
}

export const VideoPlayer = ({ language }) => {
  const videoId = getVideoId(language);
  return <iframe
    key={videoId}
    className="h-full w-full"
    src={`https://www.youtube-nocookie.com/embed/${videoId}?rel=0`}
    title="Video"
    referrerPolicy="strict-origin-when-cross-origin"
    allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    allowFullScreen
  />
};